/*
 * The idea here is not to include Bootstrap completely, but only components that we actually use from the
 *
 *   node_modules/bootstrap/js/src
 *
 * Include folder.
 *
 **/

// import 'bootstrap'

// import 'bootstrap/js/src/dropdown'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tooltip'
